import { LitElement, html, css } from 'lit-element';
import { flattenObject } from '../util/object-helpers';
import { HeaderStyles } from '../styles/header-styles';
import { DETAIL_MODES } from '../form/constants';
import '@trumedianetworks/tmn-core-components/src/tmn-grid';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-radio';
import '@trumedianetworks/tmn-core-components/src/tmn-tabs';
import '../form/form-element-user';

import { AUTHORIZATIONS } from '../authorizations/authorizations';
const { CAN_EDIT_USER_TOKENS, CAN_VERIFY_USER_DEVICES, CAN_SEE_USER_DEVICES } = AUTHORIZATIONS;
export class UserDetailBase extends LitElement {
    constructor() {
        super();
        this.renderTemplateItem = this.renderTemplateItem.bind(this);
        this.detailMode = DETAIL_MODES.VIEW;
    }

    static get styles() {
        return [
            HeaderStyles.styles,
            css`
                :host {
                    max-width: 1400px;
                    background: white;
                    display: flex;
                    flex-flow: column;
                    padding: 8px;
                    background-color: var(--app-surface-color);
                    flex: 1 1 100%;
                    min-width: 535px;
                }
                .group {
                    margin: 0 10px 6px 10px;
                }
                .errors {
                    border: 1px solid var(--app-error-color);
                    padding: 8px;
                }
                .errors h2 {
                    color: var(--app-error-color);
                }
                .controls-container {
                    display: flex;
                    flex-wrap: wrap;
                    margin: 6px 6px 12px 6px;
                }

                .controls-container > * {
                    margin-right: 6px;
                    margin-bottom: 6px;
                }
                .fixed-header {
                    background-color: var(--app-surface-color);
                }
                h1 {
                    margin-bottom: 6px;
                }
                @media (max-width: 1024px) {
                    :host {
                        min-width: 0;
                    }
                }
            `,
        ];
    }

    static get properties() {
        return {
            userTemplate: {
                type: Object,
            },
            validationErrors: {
                type: Object,
            },
            passedValidations: {
                type: Object,
            },
            // maybe rm?
            userData: {
                type: Object,
            },
            activeAuthSite: {
                type: String,
            },
            detailMode: {
                type: String,
            },
            isSaving: {
                type: Boolean,
            },
            isLoading: {
                type: Boolean,
            },
            authorizations: {
                type: Array,
            },
        };
    }

    render() {
        return html`<div class="fixed-header">${this.renderHeader()}</div>
            ${this.renderMain()}`;
    }

    renderMain() {}

    renderHeader() {}

    renderStatusMessages() {
        const { isLoading, isSaving } = this;
        if (isLoading) {
            return html`<div>Loading...</div>`;
        }
        if (isSaving) {
            return html`<div>Saving...</div>`;
        }
    }

    renderForm() {
        const { userTemplate, isLoading, isSaving } = this;
        if (isLoading || isSaving) {
            return this.renderStatusMessages();
        }
        if (!userTemplate) {
            return html`<div>No template found</div>`;
        }

        if (this.isViewMode()) {
            return this.renderViewDetails();
        }
        return this.renderEditForm();
    }

    isViewMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.VIEW;
    }

    isEditMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.EDIT;
    }

    renderValidationErrors() {
        const { validationErrors } = this;
        if (validationErrors && Object.keys(validationErrors).length) {
            // flatten tweak display
            const keySeparator = ' -> ';
            const flattenedValidationObj = flattenObject(validationErrors, keySeparator);
            return html` <div class="errors">
                <h2>Validation Errors</h2>
                <ul>
                    ${Object.entries(flattenedValidationObj).map(([key, msg]) => {
                        return html`<li><b>${key}</b>: ${msg}</li>`;
                    })}
                </ul>
            </div>`;
        }
    }
    // should this be more granular?
    renderControls() {}

    renderEditForm() {
        const { userTemplate } = this;
        return this.renderGroup(userTemplate);
    }

    renderViewDetails() {
        const { userTemplate } = this;
        return html`${this.renderGroup(userTemplate)}`;
    }

    renderGroup(group, groupKey, parentPath = [], { rowDisplayFormat = false } = {}) {
        const direction = rowDisplayFormat ? 'row' : 'column';
        const size = rowDisplayFormat ? '3' : '';
        return html`${this.renderGroupHeader(groupKey, parentPath.length)}
            <tmn-grid class="group" container .direction=${direction}>
                ${Object.entries(group).map((kvp) => {
                    return html`<tmn-grid container .direction=${direction} item .md=${size}>
                        ${this.renderTemplateItem(kvp, parentPath)}</tmn-grid
                    >`;
                })}
            </tmn-grid>`;
    }

    renderTemplateItem([key, itemTemplate], parentPath = []) {
        if (
            typeof itemTemplate === 'object' &&
            itemTemplate?.type === 'GROUP' &&
            itemTemplate?.properties
        ) {
            parentPath = [...parentPath.slice(0), key];
            return this.renderGroup(itemTemplate.properties, key, parentPath, {
                rowDisplayFormat: itemTemplate.rowDisplayFormat,
            });
        }
        const path = [...parentPath.slice(0), key].join('.');
        return this.renderFormElement(itemTemplate, path);
    }

    // todo set rowDisplayFormat false in bulk selector so we can line up the checkboxes for apply etc
    renderFormElement(itemTemplate, path) {
        return html`<form-element-user
            .itemTemplate=${itemTemplate}
            .path=${path}></form-element-user>`;
    }

    renderGroupHeader(label, depth = 0) {
        switch (depth) {
            case 0: {
                return null;
            }
            case 1:
                return html`<h2>${label}</h2>`;
            case 2:
                return html`<h3>${label}</h3>`;
            case 3:
                return html`<h4>${label}</h4>`;
            default:
                return html`<h4>${label}</h4>`;
        }
    }
}
